/*
  This file tests the signalling server.
 */


const fetch = require('node-fetch');


export function testSignalling(test, host, port) {
  const signalling_connectivity = new SignallingConnectivity(test, host, port);
  signalling_connectivity.run();
}

// signalling.js
function SignallingConnectivity(test, host, port) {
    this.test = test;
    this.host = host;
    this.port = port;
}

SignallingConnectivity.prototype = {
  run() {
    const host = this.host;
    const port = this.port;
    const url = `https://${host}:${port}/proxy-token`;
    fetch(url, {
      method: 'POST',
      headers: {
          'Content-type': 'application/json; charset=UTF-8',
          'Authorization': 'No'
      }
      })
    .then(response => response.json())
    .then(tokenObj => {
        this.test.reportSuccess('Token created successfully.');
        let hastokenProperty = Object.prototype.hasOwnProperty.call(tokenObj, "token");
        if(hastokenProperty === false) {
          this.test.reportError(`Token creation failed due to error: ${tokenObj.error}`);
          this.test.done();
        } else {
          let VideoSize = {
            "LD": [80, 45, 640, 360]
          };
          let StreamOpt = {
            video: true,
            audio: true,
            data: true,
            videoSize: VideoSize.SD,
            attributes: { name: "Test connectivity" }
          };
          let log_level = EnxRtc.Logger.getLogLevel();
          EnxRtc.Logger.setLogLevel(EnxRtc.Logger.NONE);
          EnxRtc.joinRoom(tokenObj.token, StreamOpt, (success, error) => {
            EnxRtc.Logger.setLogLevel(log_level);
            if (error && error != null) {
              // Look for error.type and error.msg.name to handle Exception
                this.test.reportError(`Room not joined due to error: ${error.type }`);
                this.test.done();
            } else if (success && success != null) {
              let rm = null;
              rm = success.room;
              rm.disconnect();
              this.test.reportSuccess('Room joined successfully.');
              this.test.done();
            }
          }
        )
      }
    })
    .catch((error) => {
      this.test.reportError(`Token creation failed due to error: ${error}`);
      this.test.done();
    });
  }
};



//////////////////
// WEBPACK FOOTER
// ./src/testSignallingServer/signalling.js
// module id = 212
// module chunks = 0